const EditBool = ({ trueLabel = "Y", falseLabel = "N", onChange, value }) => {
  return (
    <div className="border-b border-b-[#EBECF1] p-2 px-3 flex gap-1 items-center justify-center">
      <button
        onClick={() => onChange(true)}
        className={`${value ? "text-emerald-500 font-semibold" : ""} cursor-pointer`}
        disabled={value}
      >
        {trueLabel}
      </button>
      <span>/</span>
      <button
        onClick={() => onChange(false)}
        className={`${!value ? "text-red-500 font-semibold" : ""} cursor-pointer`}
        disabled={!value}
      >
        {falseLabel}
      </button>
    </div>
  )
}

export default EditBool
